<template>
  <div class="proposal__bg">
    <div class="proposal__bg-content">
      <div class="proposal__bg-content__row">
        <proposal-card :proposal="proposalTemplate" templateCard />
      </div>
      <div class="proposal__bg-content__row">
        <r-text>{{ $t("proposal.hint") }}</r-text>
      </div>
    </div>
  </div>
</template>

<script>
import proposalCard from "../../renderers/proposal-card";

const proposalTemplate = {
  name: "AleksanderV",
  company: "Simetra"
};

export default {
  components: { proposalCard },
  data() {
    return {
      proposalTemplate
    };
  }
};
</script>

<style lang="scss">
.proposal__bg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 48px;
  box-sizing: border-box;
  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 320px;
    text-align: center;
    &__row {
      margin-bottom: 16px;
      &:nth-child(2) {
        margin-bottom: 32px;
      }
      .r-text {
        color: var(--text_secondary) !important;
      }
    }
  }

  .proposal-card {
    width: 200px;
  }
}
</style>

<i18n>
{
  "ru": {
    "proposal": {
      "hint": "Чтобы создать нового демо-пользователя выберите его из списке"
    }
  },
  "en": {
    "proposal": {
      "hint": "To create a new demo user, please select him from the list"
    }
  }
}
</i18n>
